var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowCircleSkew = function SvgArrowCircleSkew(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 31,
    height: 31,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeWidth: 0.999,
    d: "M15.979 29.292c-7.354 0-13.315-5.961-13.315-13.315S8.624 2.662 15.979 2.662c7.353 0 13.314 5.961 13.314 13.315s-5.96 13.315-13.314 13.315Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "var(--c-basic-black)",
    strokeLinecap: "square",
    strokeLinejoin: "round",
    strokeWidth: 0.999,
    d: "m10.953 10.954 9.146 9.146M21.003 11.857v9.146h-9.146"
  })));
};
export default SvgArrowCircleSkew;